import { Box } from '@mui/material';
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { useController } from 'react-hook-form';

import Button from '../././Button';

import { DESTROY_FIELD } from './inputTypes/AssociationInput/NestedFormFields';
import HiddenInput from './inputTypes/HiddenInput';
import OmniInput from './OmniInput';
import { InputProps, InputRenderer, InputType } from './types';

const RemoveValueButton = ({ index, inputProps, values }: { values: any; inputProps: InputProps; index: number }) => {
  const handleRemove = () => {
    const newValue = values.slice();
    newValue.splice(index, 1);

    inputProps.onChange(newValue);
  };

  return (
    <Button variant="text" onClick={handleRemove}>
      <FontAwesome name="times" />
    </Button>
  );
};

const RemoveAssociationButton = ({ attribute, index, values }: { index: number; attribute?: string; values: any }) => {
  const prefix = `${attribute}.${index}`;
  const {
    field: { onChange: setIsDestroyed, value: isDestroyed },
  } = useController({ name: `${prefix}.${DESTROY_FIELD}` });

  if (isDestroyed && !values[index]?.id) {
    return null;
  }

  return (
    <Button variant="text" onClick={() => setIsDestroyed(!isDestroyed)}>
      <FontAwesome name={isDestroyed ? 'reply' : 'times'} />
    </Button>
  );
};

const MultipleFields = (props: InputRenderer & { type: InputType }) => {
  const { attribute, inputProps, required, type } = props;
  const values = Array.isArray(inputProps.value) ? inputProps.value : [];
  const handleAdd = () => {
    const newValues = values.slice();
    newValues.push('');

    inputProps.onChange(newValues);
  };
  const handleChange = (index: number) => (e: { target: { value: string | number | null } }) => {
    const newValue = values.slice();
    newValue[index] = e.target.value;

    inputProps.onChange(newValue);
  };

  return (
    <>
      {values.map((_, index) => (
        <Box
          key={index}
          sx={{
            alignItems: 'center',
            display: 'flex',
            marginBottom: '0.5rem',
          }}
        >
          <OmniInput
            {...props}
            index={index}
            inputProps={{ ...inputProps, onChange: handleChange(index), value: values[index] }}
          />
          {type === InputType.AssociationInput ? (
            <RemoveAssociationButton attribute={attribute} index={index} values={values} />
          ) : (
            <RemoveValueButton index={index} inputProps={inputProps} values={values} />
          )}
        </Box>
      ))}
      {required && <HiddenInput inputProps={{ value: values[0], onChange: inputProps.onChange }} required={required} />}
      <div>
        <Button icon="plus" variant="text" onClick={handleAdd}>
          Toevoegen
        </Button>
      </div>
    </>
  );
};

export default MultipleFields;
